import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function ImportantNotice() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3129">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3130">
        <div className="flex items-start gap-4 p-5 rounded-xl mb-12 border-2" style={{
        backgroundColor: '#fffbeb',
        borderColor: '#c8a84b'
      }} data-id="element-3131">
          <AlertTriangleIcon size={24} className="flex-shrink-0 mt-0.5" style={{
          color: '#c8a84b'
        }} data-id="element-3132" />
          <p className="text-base font-medium" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3133">
            This is <strong data-id="element-3134">NOT</strong> a self defense class. It has nothing to
            do with firearms. This is a crime prevention and personal safety
            seminar.
          </p>
        </div>
      </div>
    </div>;
}